import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Upload,
  InputNumber,
} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import FileLink from "../FileLink/FileLink";

import {
  updateDocumentRequest,
  createDocumentRequest,
  createPatientProfileDocumentRequest,
  updatePatientProfileDocumentRequest,
  getSitesRequest,
} from "../../api/requests";

import {
  getDocumentCreatePermission,
  getDocumentUpdatePermission,
  getDocumentTrainingReadPermission,
  getDocumentPublicReadPermission,
  getDocumentPerSiteReadPermission,
  getDocumentGeneralPrivateReadPermission,
  getDocumentGeneralReadPermission,
  getDocumentValidationReadPermission,
  getDocumentPharmacyBinderPermission,
  getDocumentStudyRegulatoryBinderPermission,
  getPatientDocumentCreatePermission,
  getPatientDocumentUpdatePermission, getDocumentPerSitePrivateReadPermission,
} from "../../reducers/user/selectors";

import classes from "./DocumentForm.css";
import { logout } from "../../reducers/user/actions";
import moment from "moment";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

export const documentTypes = {
  // Site Specific category
  site_accreditation: "Site accreditation",
  doctor_license: "Professional/Medical license",
  training_completion_certificate: "Training Completion Certificate",
  cv: "CV",
  gcp_certificates: "GCP Certificates",
  reb_ethics_approval_letter:
    "REB/Ethics approval letter, annual renewals, amendments",
  ethics_membership_list: "Ethics Membership List",
  reb_ethics_correspondence: "REB/Ethics Correspondence",
  approved_consent_form:
    "Approved Consent forms for both patient and surrogate",
  site_doa_log: "Site DOA log",
  site_training_log: "Site training log",
  protocol_signature_page: "Protocol Signature Page",
  reba_form: "REBA (Health Canada) Form",
  ctsi: "CTSI",
  qiu: "QIU",
  nol: "NOL",
  site_monitoring: "Site Monitoring",
  // Other
  other: "Other Documents",
  // Public category
  main_study: "Main Study Documents",
  study_manuals: "Study Manuals",
  assessment_tools: "Assessment Tools",
  forms: "Forms",
  siv_presentations: "SIV Presentations",
  relevant_communications: "Relevant Communications",
  // Training Category
  user_guide: "User Guide",
  technical_admin_user_guide: "Technical Admin User Guide",
  // Validation Category
  master_validation_plan: "Master Validation Plan",
  master_validation_report: "Master Validation Report",
  installation_qualication_plan: "Installation Qualication Plan",
  installation_qualication_report: "Installation Qualication Report",
  operational_qualitification_plan: "Operational Qualitification Plan",
  operational_qualitification_report: "Operational Qualitification Report",
  perfomance_qualification_plan: "Perfomance Qualification Plan",
  perfomance_qualification_report: "Perfomance Qualification Report",
  testing_plan: "Testing Plan",
  testing_log: "Testing Log",
  data_managemnt_plan: "Data Management Plan",
  system_architecture: "System Architecture",
  // Study Regulatory Binder
  site_pi_forms: "Site / PI Forms",
  site_personnel_qualifications: "Site Personnel Qualifications",
  forms_agreements: "Forms / Agreements",
  protocol_amendment_signature:
    "Protocol / Amendment(s) Signature Pages and Acknowledgements",
  investigator_brochure_addendum:
    "Investigator Brochure / Addendum(s) Signature Pages and  Acknowledgements",
  informed_consents_forms: "Informed Consents Forms ",
  subject_logs_forms: "Subject Logs & Forms (Completed)",
  "safety ": "Safety  ",
  local_laboratory: "Local Laboratory",
  imaging: "Imaging",
  "competent_authority	": "Competent Authority	",
  irb_iec: "IRB/IEC (Central and Local)",
  other_authority:
    "Other Authority (i.e. Hospital/Scientific Review Board, Radiation committee, etc.)",
  monitoring_documentation: "Monitoring Documentation",
  study_supplies: "Study Supplies",
  site_correspondence: "Site Correspondence",
  equipment: "Equipment",
  // Pharmacy Binder
  study_staff: "Study Staff & Contact Information",
  protocol_amendment: "Protocol / Amendment(s)",
  schedule_of_events: "Schedule of Events (current approved version)",
  investigator_brochure:
    "Investigator Brochure(s) and addendums / Package Inserts",
  pharmacy_manual: "Pharmacy Manual",
  msds_certificates: "MSDS, Certificates of Analysis & QP Release",
  investigational_receipt: "Investigational Product Receipt and Request",
  investigational_dispensing:
    "Investigational Product Dispensing & Accountability",
  investigational_disposition: "Investigational Product Disposition / Return",
  investigational_storage: "Investigational Product Storage   ",
  training_material: "Training Material",
  correspondence: "Correspondence",
  general_patient_document: "General patient document",
};

export const categoryPublic = [
  "main_study",
  "study_manuals",
  "assessment_tools",
  "forms",
  "siv_presentations",
  "relevant_communications",
  "other",
];
export const categoryGeneral = ["other"];
export const categoryGeneralPrivate = ["other"];
export const categoryTraining = [
  "user_guide",
  "technical_admin_user_guide",
  "other",
];
export const categoryPerSite = [
  "site_accreditation",
  "doctor_license",
  "training_completion_certificate",
  "cv",
  "gcp_certificates",
  "reb_ethics_approval_letter",
  "ethics_membership_list",
  "reb_ethics_correspondence",
  "approved_consent_form",
  "site_doa_log",
  "site_training_log",
  "protocol_signature_page",
  "reba_form",
  "ctsi",
  "qiu",
  "site_monitoring",
];
export const categoryValidation = [
  "master_validation_plan",
  "master_validation_report",
  "installation_qualication_plan",
  "installation_qualication_report",
  "operational_qualitification_plan",
  "operational_qualitification_report",
  "perfomance_qualification_plan",
  "perfomance_qualification_report",
  "testing_plan",
  "testing_log",
  "data_managemnt_plan",
  "system_architecture",
  "other",
];
export const categoryStudyRegulatoryBinder = [
  "site_pi_forms",
  "site_personnel_qualifications",
  "forms_agreements",
  "protocol_amendment_signature",
  "investigator_brochure_addendum",
  "informed_consents_forms",
  "subject_logs_forms",
  "safety ",
  "local_laboratory",
  "imaging",
  "competent_authority	",
  "irb_iec",
  "other_authority",
  "monitoring_documentation",
  "study_supplies",
  "site_correspondence",
  "equipment",
];
export const categoryPharmacyBinder = [
  "study_staff",
  "protocol_amendment",
  "schedule_of_events",
  "investigator_brochure",
  "pharmacy_manual",
  "msds_certificates",
  "investigational_receipt",
  "investigational_dispensing",
  "investigational_disposition",
  "investigational_storage",
  "training_material",
  "correspondence",
];

export const categoryPatientDocument = ["general_patient_document"];

class DocumentPatientForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const document = { ...values };
          document.name = get(document, "document_file.fileList", []).slice(
            -1
          ).name;
          document.category = "per_site";
          document.document_file = values.document_file.file;

          const formData = new FormData();

          if (values.document_file && values.document_file.file) {
            formData.append("document_file", values.document_file.file);
          }
          formData.append("name", values.name);
          formData.append("start_year", values.start_year.format("YYYY-MM-DD"));
          formData.append(
            "expiry_year",
            values.expiry_year ? values.expiry_year.format("YYYY-MM-DD") : null
          );
          formData.append("type", values.type);
          formData.append("category", values.category);
          formData.append("comments", values.comments);
          formData.append("order_index", values.order_index);
          if (values.category === "per_site" || values.category === "per_site_private") {
            formData.append("site_id", values.site_id);
          }

          if (this.props.patient) {
            formData.append(
              "subject_profile_id",
              this.props.patient.profile.id
            );

            formData.append("site_id", this.props.patient.site.id);
          }

          if (this.props.id) {
            if (this.props.patient) {
              await updatePatientProfileDocumentRequest(
                this.props.id,
                formData
              );
            } else {
              await updateDocumentRequest(this.props.id, formData);
            }
          } else {
            if (this.props.patient) {
              await createPatientProfileDocumentRequest(formData);
            } else {
              await createDocumentRequest(formData);
            }
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: this.props.i18n.t('Success') },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onCategoryChange = () => {
    this.props.form.setFieldsValue({ type: null });
  };

  render() {
    const { isLoading, requestResult, sites } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      patientDocumentCreatePermission,
      documentUpdatePermission,
      patientDocumentUpdatePermission,
      documentCreatePermission,
      id,
      isNew,
      withPatient,
    } = this.props;

    const categoryVal = getFieldValue("category");

    const createPermissions = withPatient
      ? patientDocumentCreatePermission
      : documentCreatePermission;
    const updatePermissions = withPatient
      ? patientDocumentUpdatePermission
      : documentUpdatePermission;

    const isEditable = id ? updatePermissions : createPermissions;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              this.props.i18n.t('NamespaceDocumentForm:Add New Document')
            ) : (
              ""
            )}
          </h4>

          {!get(this.props, "patient.profile.id") && withPatient && (
            <Row>
              <Col>
                <Alert
                  type="error"
                  message={this.props.i18n.t('Note') + ': ' +this.props.i18n.t('NamespaceDocumentForm:You must create the profile for this subject in order to upload the documents!')}
                />
                <br />
              </Col>
            </Row>
          )}

          <Row gutter={12}>
            <Col>
              <label>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                  })(
                    <Upload
                      disabled={!isEditable}
                      accept=".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4,.eml,.msg,.zip,.vsdx,.xlsm,.xlsx,.accdb"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.url
                          ? this.props.i18n.t('Change file')
                          : this.props.i18n.t('NamespaceDocumentForm:Add New Document')}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>

              {!this.props.form.getFieldValue("document_file") &&
              this.props.url && (
                <div>
                  <FileLink url={this.props.url} text="File preview" />
                  <br />
                  <br />
                </div>
              )}
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Index')}</b>
                <Form.Item style={{ marginBottom: "12px" }}>
                  {getFieldDecorator(`order_index`, {
                    initialValue: get(this.props, "order_index", ""),
                  })(<InputNumber disabled={!isEditable} placeholder="999" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Category')}</b>
                <Form.Item>
                  {getFieldDecorator("category", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "category"),
                  })(
                    this.props.patient ? (
                      <Select
                        disabled={!isEditable}
                        onChange={this.onCategoryChange}
                      >
                        <Option value="patient_documents">
                          {this.props.i18n.t('NamespaceDocumentForm:Patient documents')}
                        </Option>
                      </Select>
                    ) : (
                      <Select
                        disabled={!isEditable}
                        onChange={this.onCategoryChange}
                      >
                        <Option
                          value="public"
                          disabled={!this.props.documentPublicReadPermission}
                        >
                          {this.props.i18n.t('Public')}
                        </Option>
                        <Option
                          value="general"
                          disabled={!this.props.documentGeneralReadPermission}
                        >
                          {this.props.i18n.t('NamespaceDocumentForm:Central Shared')}
                        </Option>
                        <Option
                          value="general_private"
                          disabled={
                            !this.props.documentGeneralPrivateReadPermission
                          }
                        >
                          {this.props.i18n.t('NamespaceDocumentForm:Central Private')}
                        </Option>
                        <Option
                          value="per_site"
                          disabled={!this.props.documentPerSiteReadPermission}
                        >
                          {this.props.i18n.t('NamespaceDocumentForm:Site Specific')}
                        </Option>
                        <Option
                          value="per_site_private"
                          disabled={!this.props.documentPerSitePrivateReadPermission}
                        >
                          {this.props.i18n.t('NamespaceDocumentForm:Site Specific Private')}
                        </Option>
                        <Option
                          value="training"
                          disabled={!this.props.documentTrainingReadPermission}
                        >
                          {this.props.i18n.t('Training')}
                        </Option>
                        <Option
                          value="validation"
                          disabled={
                            !this.props.documentValidationReadPermission
                          }
                        >
                          {this.props.i18n.t('Validation')}
                        </Option>
                        <Option
                          value="study_regulatory_binder"
                          disabled={
                            !this.props.documentStudyRegulatoryBinderPermission
                          }
                        >
                          {this.props.i18n.t('Study Regulatory Binder')}
                        </Option>
                        <Option
                          value="pharmacy_binder"
                          disabled={
                            !this.props.documentPharmacyBinderPermission
                          }
                        >
                          {this.props.i18n.t('Pharmacy Binder')}
                        </Option>
                      </Select>
                    )
                  )}
                </Form.Item>
              </label>
            </Col>

            {categoryVal === "per_site" && (
              <Col lg={12}>
                <label>
                  <b>{this.props.i18n.t('Site ID')}</b>
                  <Form.Item>
                    {getFieldDecorator("site_id", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "site_id"),
                    })(
                      <Select
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("Select Site ID")}
                        style={{ width: "100%" }}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption
                      >
                        {sites.sort(
                          (a, b) =>
                            +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                        ).filter(({ state }) => state === 'active').map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
          </Row>
          <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('Document type')}</b>
                <Form.Item>
                  {getFieldDecorator("type", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "type"),
                  })(
                    <Select disabled={!isEditable}>
                      {(() => {
                        let documentTypeList = [];

                        if (categoryVal === "public") {
                          documentTypeList = categoryPublic;
                        }
                        if (categoryVal === "general") {
                          documentTypeList = categoryGeneral;
                        }
                        if (categoryVal === "general_private") {
                          documentTypeList = categoryGeneralPrivate;
                        }
                        if (categoryVal === "per_site") {
                          documentTypeList = categoryPerSite;
                        }
                        if (categoryVal === "training") {
                          documentTypeList = categoryTraining;
                        }
                        if (categoryVal === "validation") {
                          documentTypeList = categoryValidation;
                        }
                        if (categoryVal === "study_regulatory_binder") {
                          documentTypeList = categoryStudyRegulatoryBinder;
                        }
                        if (categoryVal === "pharmacy_binder") {
                          documentTypeList = categoryPharmacyBinder;
                        }
                        if (categoryVal === "patient_documents") {
                          documentTypeList = categoryPatientDocument;
                        }

                        return documentTypeList.map((key) => (
                          <Option key={key} value={key}>
                            {documentTypes[key]}
                          </Option>
                        ));
                      })()}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Document Name')}</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceDocumentForm:Year')}</b>
                <Form.Item>
                  {getFieldDecorator("start_year", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "start_year")
                      ? moment(get(this.props, "start_year"))
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceDocumentForm:Renewal/expiry year')}</b>
                <Form.Item>
                  {getFieldDecorator("expiry_year", {
                    initialValue: get(this.props, "expiry_year")
                      ? moment(get(this.props, "expiry_year"))
                      : null,
                  })(
                    <DatePicker
                      disabled={!isEditable}
                      placeholder="yyyy-mm-dd"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t('Comments')}</b>
                <Form.Item>
                  {getFieldDecorator("comments", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "comments"),
                  })(<Input.TextArea disabled={!isEditable} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                  disabled={
                    !get(this.props, "patient.profile.id") && withPatient
                  }
                >
                  {this.props.i18n.t('Save')}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  patientDocumentCreatePermission: getPatientDocumentCreatePermission(state),
  patientDocumentUpdatePermission: getPatientDocumentUpdatePermission(state),
  documentCreatePermission: getDocumentCreatePermission(state),
  documentUpdatePermission: getDocumentUpdatePermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(
    state
  ),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
  documentPerSitePrivateReadPermission: getDocumentPerSitePrivateReadPermission(state),
  documentPharmacyBinderPermission: getDocumentPharmacyBinderPermission(state),
  documentStudyRegulatoryBinderPermission: getDocumentStudyRegulatoryBinderPermission(
    state
  ),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "user" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DocumentPatientForm))
);



// WEBPACK FOOTER //
// ./src/components/DocumentForm/DocumentPatientForm.js